// Thin DOM accessors. Lookups in this hand-rolled SPA are inherently dynamic;
// returning `any` keeps call sites readable without a null-guard at every
// `getElementById`. `qsa` returns a real array so `.map`/`.forEach` callbacks
// are contextually typed (no implicit-any).
export function $(id: string): any { return document.getElementById(id); }
export function qs(sel: string, root: any = document): any { return root.querySelector(sel); }
export function qsa(sel: string, root: any = document): any[] { return Array.from(root.querySelectorAll(sel)); }
// Escape user-controlled text before it reaches innerHTML. Most of this SPA
// renders names from the constrained `byKey` table (no user HTML), but a few
// surfaces show free text — e.g. a backup's `label_hint` — and must escape.
export function escapeHtml(s: string): string {
  return String(s).replace(/[&<>"']/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));
}
